/* General Actions */
export const ERROR = 'ERROR',
             EMAIL_FILE = 'EMAIL_FILE',
             FETCH_MANAGERS = 'FETCH_MANAGERS',
             SET_DOCS = 'SET_DOCS',
             FETCH_CULT_EMPLOYEES = 'FETCH_CULT_EMPLOYEES',
             FETCH_CERTIFICATION = 'FETCH_CERTIFICATION',
             CLEAR_FORM = ' CLEAR_FORM';

/* Chemical Actions */
export const CREATE_CHEMICAL = 'CREATE_CHEMICAL',
             FETCH_CHEMICALS = 'FETCH_CHEMICALS',
             SELECT_CHEMICAL = 'SELECT_CHEMICAL',
             SELECT_CHEMICAL_TO_EDIT = 'SELECT_CHEMICAL_TO_EDIT',
             EDIT_CHEMICAL = 'EDIT_CHEMICAL';

/* Report Actions */
export const FETCH_FIELDS = 'FETCH_FIELDS',
             FETCH_CULTIVATION_REPORT = 'FETCH_CULTIVATION_REPORT';

/* Chemical Application Actions */
export const ADD_SOLUTION = 'ADD_SOLUTION',
             EDIT_SOLUTION = 'EDIT_SOLUTION',
             DELETE_SOLUTION = 'DELETE_SOLUTION',
             SELECT_SOLUTION_TO_EDIT = 'SELECT_SOLUTION_TO_EDIT',
             SET_TOTAL_GALLONS = 'SET_TOTAL_GALLONS',
             PREPARE_DATA = 'PREPARE_DATA',
             CREATE_CHEMICAL_APPLICATION = 'CREATE_CHEMICAL_APPLICATION',
             EDIT_CHEMICAL_APPLICATION = 'EDIT_CHEMICAL_APPLICATION',
             FETCH_CHEMICAL_APPLICATIONS = 'FETCH_CHEMICAL_APPLICATIONS',
             SELECT_FIELD = 'SELECT_FIELD',
             DELETE_CHEMICAL_APPLICATION = 'DELETE_CHEMICAL_APPLICATION',
             SELECT_CHEMICAL_APPLICATION_TO_EDIT = 'SELECT_CHEMICAL_APPLICATION_TO_EDIT',
             SELECT_FIELD_FOR_EDIT = 'SELECT_FIELD_FOR_EDIT',
             SELECT_APPLICATION_TO_VIEW = 'SELECT_APPLICATION_TO_VIEW';

/* Fertilizer Actions */
export const CREATE_FERTILIZER_APPLICATION = 'CREATE_FERTILIZER_APPLICATION',
             ADD_FERTILIZER = 'ADD_FERTILIZER',
             EDIT_FERTILIZER = 'EDIT_FERTILIZER',
             SELECT_FERTILIZER_TO_EDIT = 'SELECT_FERTILIZER_TO_EDIT',
             DELETE_FERTILIZER = 'DELETE_FERTILIZER',
             PREPARE_FERTILIZER = 'PREPARE_FERTILIZER',
             SET_FERTILIZER_FORM = 'SET_FERTILIZER_FORM',
             FETCH_FERTILIZER_APPLICATIONS = 'FETCH_FERTILIZER_APPLICATIONS',
             SELECT_FERTILIZER_APPLICATION = 'SELECT_FERTILIZER_APPLICATION',
             DELETE_FERTILIZER_APPLICATION = 'DELETE_FERTILIZER_APPLICATION',
             SELECT_FERT_APP_TO_EDIT = 'SELECT_FERT_APP_TO_EDIT',
             EDIT_FERTILIZER_APPLICATION = 'EDIT_FERTILIZER_APPLICATION';

/* Mowing Actions */
export const ADD_MOWING_RECORD = 'ADD_MOWING_RECORD',
             EDIT_MOWING_RECORD = 'EDIT_MOWING_RECORD',
             SELECT_MOW_TO_EDIT = 'SELECT_MOW_TO_EDIT',
             DELETE_MOWING_RECORD = 'DELETE_MOWING_RECORD',
             PREPARE_MOWING_APPLICATION = 'PREPARE_MOWING_APPLICATION',
             CREATE_MOWING_APPLICATION = 'CREATE_MOWING_APPLICATION',
             FETCH_MOWING_APPLICATIONS = 'FETCH_MOWING_APPLICATIONS',
             SELECT_MOWING_APPLICATION = 'SELECT_MOWING_APPLICATION',
             DELETE_MOWING_APPLICATION = 'DELETE_MOWING_APPLICATION',
             SELECT_MOW_APP_TO_EDIT = 'SELECT_MOW_APP_TO_EDIT',
             EDIT_MOWING_APPLICATION = 'EDIT_MOWING_APPLICATION';

/* Tree Inventory Actions */
export const SET_FORM_TYPE = 'SET_FORM_TYPE',
             PREPARE_TREE_INVENTORY = 'PREPARE_TREE_INVENTORY',
             CREATE_INVENTORY_REQUEST = 'CREATE_INVENTORY_REQUEST',
             FETCH_INVENTORY = 'FETCH_INVENTORY',
             ISSUE_OR_RECEIVE_INVENTORY_REQUEST = 'ISSUE_OR_RECEIVE_INVENTORY_REQUEST',
             APPROVE_INVENTORY_REQUEST = 'APPROVE_INVENTORY_REQUEST',
             DOWNLOAD_INVENTORY = 'DOWNLOAD_INVENTORY',
             SET_INVENTORY_TO_EDIT = 'SET_INVENTORY_TO_EDIT',
             EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST = 'EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST',
             SET_INVENTORY_TO_DELETE = 'SET_INVENTORY_TO_DELETE',
             DELETE_INVENTORY_REQUEST = 'DELETE_INVENTORY_REQUEST';

export const ADD_EMPLOYEE = 'ADD_EMPLOYEE',
             REMOVE_EMPLOYEE = 'REMOVE_EMPLOYEE',
             PREPARE_REPLANT = 'PREPARE_REPLANT',
             FETCH_REPLANTS = 'FETCH_REPLANTS',
             CREATE_REPLANT = 'CREATE_REPLANT',
             SET_REPLANT_TO_EDIT = 'SET_REPLANT_TO_EDIT',
             ADD_EMPLOYEE_TO_EDIT = 'ADD_EMPLOYEE_TO_EDIT',
             REMOVE_EMPLOYEE_FROM_EDIT = 'REMOVE_EMPLOYEE_FROM_EDIT',
             EDIT_REPLANT = 'EDIT_REPLANT',
             SET_REPLANT_TO_DELETE = 'SET_REPLANT_TO_DELETE',
             DELETE_REPLANT = 'DELETE_REPLANT';



























/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/types.js